/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseCrmSettings } from '../models/api-response-crm-settings';
import { getSettings } from '../fn/crm-settings-api/get-settings';
import { GetSettings$Params } from '../fn/crm-settings-api/get-settings';
import { updateSettings } from '../fn/crm-settings-api/update-settings';
import { UpdateSettings$Params } from '../fn/crm-settings-api/update-settings';

@Injectable({ providedIn: 'root' })
export class CrmSettingsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSettings()` */
  static readonly GetSettingsPath = '/v1/api/ui/zoho-crm/settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Response(params: GetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmSettings>> {
    return getSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings(params: GetSettings$Params, context?: HttpContext): Observable<ApiResponseCrmSettings> {
    return this.getSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCrmSettings>): ApiResponseCrmSettings => r.body)
    );
  }

  /** Path part for operation `updateSettings()` */
  static readonly UpdateSettingsPath = '/v1/api/ui/zoho-crm/settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSettings$Response(params: UpdateSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmSettings>> {
    return updateSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSettings(params: UpdateSettings$Params, context?: HttpContext): Observable<ApiResponseCrmSettings> {
    return this.updateSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseCrmSettings>): ApiResponseCrmSettings => r.body)
    );
  }

}
